import { render, staticRenderFns } from "./NavLabel.vue?vue&type=template&id=21601a2a&scoped=true"
import script from "./NavLabel.vue?vue&type=script&lang=js"
export * from "./NavLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21601a2a",
  null
  
)

export default component.exports